import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 20h18M3 4h18"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14.546 5.5c-.302 0-.546.323-.546.722v11.556c0 .399.244.722.546.722h2.909c.3 0 .545-.323.545-.722V6.222c0-.399-.244-.722-.546-.722zM6.545 5.5c-.3 0-.545.323-.545.722v11.556c0 .399.244.722.545.722h2.91c.3 0 .545-.323.545-.722V6.222c0-.399-.244-.722-.545-.722z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }